import { render } from "./moduleIndex.vue?vue&type=template&id=bbfd49cc"
import script from "./moduleIndex.vue?vue&type=script&lang=js"
export * from "./moduleIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__